export enum EnvironmentState {
  HEALTHY = "healthy", // backend is running and reporting a healthy state
  UNHEALTHY = "unhealthy", // backend is running but does not report a healthy state
  RUNNING = "running", // instance is running but backend state is unknown
  TERMINATED = "terminated", // there is a successful workflow run indicating the termination of that instance
  PENDING_TERMINATION = "pending_termination", // there is a pending workflow run for the termination of that instance
  TERMINATION_FAILED = "termination_failed", // there is a failed or cancelled workflow run for the termination of that instance
  INITIALIZED = "initialized", // there is a successful workflow run indicating that instance should have been successfully created
  PENDING_INITIALIZATION = "pending_initialization", // there is a pending workflow run for the creation of that instance
  INITIALIZATION_FAILED = "initialization_failed", // there is a failed or cancelled workflow run for the creation of that instance
  REFRESHING = "refreshing",
  DEPLOYING = "deploying", // temporary state, internal to the Admin Panel until FOLK-11443 is resolved
  UNKNOWN = "unknown",
  STOPPED = "stopped", // instance is stopped
}

export interface IEnvironment {
  name: string;
  creationDate: number;
  terminationDate: number | undefined;
  baseURL: string;
  registryURL: string;
  stage: number;
  backendImageId: string | undefined;
  backendImageName: string | undefined;
  deploymentDate: number | undefined;
  previous?: IEnvironment;
  isDefault: boolean | undefined;
  state: EnvironmentState | undefined;
  publicIpAddress: string | undefined;
  privateIpAddress: string | undefined;
  gameServerCount: number | undefined;
  activePackageId: string | undefined;
  activeSchemaBranch: string | undefined;
  activeSchemaVersion: number | undefined;
  serverImageBranch: string | undefined;
  serverImageId: string | undefined;
  clientBranch: string | undefined;
  ttl: number | undefined;
  ownerEmail: string | undefined;
  deploymentLogs: string[] | undefined;
  instanceType: string | undefined;
}

export interface EnvType {
  name: string;
  values: number[];
}

export interface IEnvironmentMetricsDataPoint {
  memoryUsedMb: number;
  memoryTotalMb: number;
  cpuUsagePercent: number;
  diskUsedGb: number;
  diskTotalGb: number;
}

export const LOCAL_ENV: IEnvironment = {
  name: "localhost",
  creationDate: 0,
  terminationDate: undefined,
  baseURL: "http://localhost:3001/",
  registryURL: "http://localhost:3001/",
  stage: 1,
  backendImageId: undefined,
  backendImageName: undefined,
  deploymentDate: 0,
  isDefault: undefined,
  state: EnvironmentState.HEALTHY,
  publicIpAddress: "127.0.0.1",
  privateIpAddress: "127.0.0.1",
  gameServerCount: 0,
  activePackageId: undefined,
  activeSchemaBranch: undefined,
  activeSchemaVersion: undefined,
  serverImageBranch: undefined,
  serverImageId: undefined,
  clientBranch: undefined,
  ttl: undefined,
  ownerEmail: undefined,
  deploymentLogs: undefined,
  instanceType: "t4g.xlarge",
};
